export const uk = {
    'add-button-text': 'Добавить',
    'add-button-text-with-count': 'Добавить — {count}',
    'add-correction': 'Новая корректировка'
};
